<script>
  import { onMount } from "svelte"
  import { querystring, push } from "svelte-spa-router"
  import notify from "../../../../../Script/notify"
  import Navbar from "../../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../../Shared/footer.svelte"
  import { queryStringToJSON } from "../../../../../Script/queryString"
  import Header from "../../Components/header.svelte"
  import LoadingScreen from "../../../SinglePublish/Components/loadingScreen.svelte"
  import BadgePublish, { updateBadgePublish } from "../../Stores/badge"
  import { fetchSingleDocTempDetails, filehashGeneration } from "../../Script/api"
  import { fetchFileTemplate } from "../../../BulkUpload/Script/bulkUpload"
  import { loadImage } from "../../../BulkUpload/Script/bulkUpload"
  import { flatenObject } from "../../../../../Script/flatenObject"
  import { loadQR } from "../../../BulkUpload/Script/bulkUpload"
  import { validateFile } from "../../../BulkUpload/Script/bulkUpload"

  /**
   * @type {Boolean} - whether to disable next button or not
   */
  let showLoading = false
  /**
   * @type {String} - massage for loading screen
   */
  let msg = "Generating Document"
  /**
   * @type {Object} - object get from window location
   */
  let query = queryStringToJSON($querystring)
  /**
   * @type {Element} - publish button element
   */
  let publishBtn
  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {closeNotification}
   */
  let closeNotification = {
    close() {},
  }

  let isDynamicFilesFound = false

  let fileToBeUploaded
  let dynamicImages = {}
  let fileData
  let haveDynamicFiles = false
  /**
   * fetch new document id details or start a fresh process for file uploading or draw signed pdf based on contition
   */
  onMount(async () => {
    try {
      if (!$BadgePublish.documentTemplateId) {
        push("/publish/badge/doctemplate")
      }

      showLoading = true

      // Make ipfs uri of the file in the stores as empty initially.
      $BadgePublish.uri = ""

      // console.log("generate", $BadgePublish.documentTemplateId)

      let documentData = await fetchSingleDocTempDetails($BadgePublish.documentTemplateId)

      if (!documentData.file) throw "We couldn't find the file template associated with the document template."

      // console.log($BadgePublish)

      // Fetch file data from the document template
      let dataFromFile = await fetchFileTemplate(documentData.file)

      // Process the file data
      fileData = processFileData(dataFromFile)

      // console.log($BadgePublish)

      checkDynamicImage(fileData)
      if (!Object.keys(dynamicImages).length) fileToBeUploaded = await generateFile(fileData)
    } catch (error) {
      const info = "PAGE: Badge Publish (Upload Document)\nEVENT: onMount"
      notify.danger(error, info)
      push("/publish/badge")
    } finally {
      showLoading = false
    }
  })

  const checkDynamicImage = (fileData) => {
    // console.log(fileData)
    let layers = JSON.parse(JSON.stringify(fileData.layers))
    // console.log(layers)
    for (let i = 0; i < layers.length; i++) {
      if (layers[i].type == "image") {
        if (layers[i].dynamic) {
          haveDynamicFiles = true
          dynamicImages[layers[i].attribute] = ""
        }
      }
    }
    // console.log(dynamicImages)
    // console.log(Object.entries(dynamicImages))
  }

  const generateDynamicImage = async () => {
    const info = "PAGE: Badge Publish (Upload Document)\nEVENT: While processing uploaded dynamic images and generating file"
    try {
      showLoading = true
      closeNotification.close()
      let layers = JSON.parse(JSON.stringify(fileData.layers))
      // console.log(layers)
      // console.log(dynamicImages)

      for (let i = 0; i < layers.length; i++) {
        if (layers[i].type == "image") {
          if (layers[i].dynamic) {
            if (!dynamicImages[layers[i].attribute]) {
              closeNotification = notify.danger("All images should be mandatory", info)
              return
            }
            layers[i].src = dynamicImages[layers[i].attribute]
          }
        }
      }
      fileData.layers = [...layers]
      // console.log(fileData)
      dynamicImages = {}
      fileToBeUploaded = await generateFile(fileData)
    } catch (error) {
      closeNotification = notify.danger("All images should be mandatory", info)
    } finally {
      showLoading = false
    }
    // await generateFile(fileData)
  }

  /**
   * Function for storing the details fetched from the file template
   *
   * @param {Object} dataFromFile - The file data containing information about the file.
   */
  const processFileData = (dataFromFile) => {
    let fileData = {}

    // Extract and store baseUri and layers information from the fetched template data
    fileData.baseUri = dataFromFile.baseUri
    fileData.layers = JSON.parse(dataFromFile.layers)
    fileData.fonts = JSON.parse(dataFromFile.fonts)
    fileData.quality = dataFromFile.quality

    // Filter out layers with dynamic images
    let layerWithDynamicImg = []
    layerWithDynamicImg = fileData.layers.filter((layer) => layer.type == "image" && layer.dynamic)

    // Set a flag indicating whether dynamic files were found
    isDynamicFilesFound = layerWithDynamicImg.length ? true : false

    return fileData
  }

  /**
   * Function for generating the file using canvas
   * @param {import("../../Script/document").bulkDocument} data
   */
  const generateFile = (fileData) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

        // Load the base image from the given 'fileData.baseUri' URL and get its dimensions
        let image = await loadImage(fileData.baseUri)

        let width = image.naturalWidth
        let height = image.naturalHeight

        // Assign the 'fileData.layers' to layers
        let layers = JSON.parse(JSON.stringify(fileData.layers))

        // Create a new canvas element and get its 2D context
        const canvas = document.createElement("canvas")
        const ctx = canvas.getContext("2d")

        // Set the canvas dimensions to match the dimensions of the base image
        canvas.height = height
        canvas.width = width

        // Draw the base image onto the canvas at (0, 0) with its original width and height
        ctx.drawImage(image, 0, 0, width, height)

        let parsedMetadata = typeof $BadgePublish.metadata == "string" ? JSON.parse($BadgePublish.metadata) : $BadgePublish.metadata

        // Flatten the metadata object of 'data' to a one-dimensional object
        let ArrflatObject = flatenObject(parsedMetadata)

        let options = typeof $BadgePublish.options == "string" ? JSON.parse($BadgePublish.options) : $BadgePublish.options

        ArrflatObject = { ...ArrflatObject, ...options, documentID: $BadgePublish.id }

        layers = bindLayerValues(ArrflatObject, layers)

        for (let i = 0; i < layers.length; i++) {
          layers[i].attribute = layers[i].attribute.charAt(0).toLowerCase() + layers[i].attribute.slice(1)
        }

        // Load a QR image based on the current timestamp and draw it on the canvas at the top-right corner
        let qr = await loadQR(new Date().toISOString())
        // let qr = await loadQR(data.dateCreated)
        ctx.drawImage(await loadImage(qr), width - 10, 0, 10, 10)

        // Loop through each layer again and render the content based on the layer type (text, image, qr)
        for (let i = 0; i < layers.length; i++) {
          // if (layers[i].type == "text") await renderText(layers[i], ctx)
          if (layers[i].type == "text") {
            if (layers[i].attribute == "expireOn" && layers[i].value) layers[i].value = new Date(layers[i].value).toDateString().slice(4)
            if (layers[i].attribute == "date") layers[i].value = new Date(layers[i].value).toDateString().slice(4)
            if (layers[i].value && layers[i].value != "text") {
              try {
                layers[i].value = String(layers[i].value).trim()
                await renderText(layers[i], ctx)
              } catch (error) {
                throw `Error: ${error.toString()}; Value: ${layers[i].value}`
              }
            }
          }
          if (layers[i].type == "image") {
            if (layers[i].dynamic) {
              let imageElement = await loadImage(layers[i].src)

              let width = layers[i].width
              let height = layers[i].height
              let xPos = layers[i].x
              let yPos = layers[i].y

              let aspectRatio = imageElement.naturalWidth / imageElement.naturalHeight

              if (aspectRatio >= 1) {
                height = Math.floor(layers[i].width / aspectRatio)
                yPos += (layers[i].height - height) / 2
              } else {
                width = Math.floor(layers[i].height * aspectRatio)
                xPos += (layers[i].width - width) / 2
              }

              ctx.drawImage(imageElement, xPos, yPos, width, height)

              // let currentLayer = layers[i].attribute.charAt(0).toLowerCase() + layers[i].attribute.slice(1)
              // let imageElement = data.filename[currentLayer]

              // let imageElement = layers[i].src
              // ctx.drawImage(imageElement, layers[i].x, layers[i].y, layers[i].width, layers[i].height)
              // ctx.drawImage(await loadImage(layers[i].src), layers[i].x, layers[i].y, layers[i].width, layers[i].height)
            } else {
              if (layers[i].src) {
                ctx.drawImage(await loadImage(layers[i].src), layers[i].x, layers[i].y, layers[i].width, layers[i].height)
              }
            }
          }
        }

        // Convert the canvas to a Blob object representing the generated image
        let blobObject = await canvasToBlob(canvas, fileData.quality)

        $BadgePublish.uri = URL.createObjectURL(blobObject)

        // Create a new File object with the Blob and provide a default filename and type
        let file = new File([blobObject], `${$BadgePublish.documentId}.jpeg`, {
          type: "image/jpeg",
        })

        resolve(file)
      } catch (error) {
        console.error(error)
        reject(error)
      }
    })
  }

  /**
   * Converts a canvas element to a Blob object.
   *
   * @param {HTMLCanvasElement} canvas - The canvas element to be converted.
   * @returns {Promise<Blob>} A Promise that resolves with the generated Blob object.
   */
  const canvasToBlob = (canvas, quality) => {
    /**
     * @typedef {Blob} Blob - Represents a binary large object (Blob) that can store binary data.
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Blob Blob}
     */

    return new Promise((resolve) => {
      /**
       * The `toBlob` method of the canvas element is used to convert it to a Blob.
       * @param {Blob} blob - The generated Blob object.
       */
      canvas.toBlob(
        (blob) => {
          // Once the Blob is created, the Promise is resolved with the Blob object.
          resolve(blob)
        },
        "image/jpeg",
        quality
      )
    })
  }

  /**
   * Renders text on a canvas using the provided data and context.
   *
   * @param {Object} data - The data object containing text rendering information.
   * @param {CanvasRenderingContext2D} ctx - The 2D rendering context of the canvas.
   * @returns {Promise<void>} A promise that resolves when the text is rendered.
   */
  const renderText = (data, ctx) => {
    return new Promise((resolve) => {
      // Check if there are any font styles applied
      if (data.fontStyles.length) {
        // Convert the fontStyles array to a string and replace commas with spaces
        let fontStyle = data.fontStyles.toString().replaceAll(",", " ")
        // Remove "Underline" from the font style
        fontStyle = fontStyle.replace("Underline", " ")
        // Set the font style for the canvas context using the combined font style, font size, and font family
        ctx.font = `${fontStyle} ${data.fontSize}px '${data.fontFamily}'`
      } else {
        // If no font styles are applied, set the font size and family directly
        ctx.font = ` ${data.fontSize}px '${data.fontFamily}'`
      }

      // Set the alignment for the text (left, center, right)
      ctx.textAlign = data.textAlign
      // Set the fill color for the text
      ctx.fillStyle = data.textColor
      // Draw the text on the canvas at the specified coordinates (x, y)
      ctx.fillText(data.value, data.x, data.y)

      // Resolve the promise to indicate that rendering is complete
      resolve()
    })
  }

  /**
   * Binds values from a flat array to corresponding layers attributes in an array of layers.
   *
   * @param {Object} flatArr - The flat array containing attribute-value pairs.
   * @param {Array} layers - The array of layers with attributes to bind values to.
   * @returns {Array} - An array of layers with updated values bound from the flat array.
   */
  const bindLayerValues = (flatArr, layers) => {
    // Map through the layers and update their values if corresponding attributes exist in the flat array
    layers = layers.map((layer) => {
      if (flatArr[layer.attribute]) {
        layer.value = flatArr[layer.attribute] // Bind the value from flat array to layer's value
      }
      return layer // Return the updated layer
    })

    return [...layers] // Return a new array with the updated layer values
  }

  /**
   * @description function for submit file are genarate file hash for uploaded file
   */
  const handleUpload = async () => {
    try {
      //Indicate message in loading screen
      msg = "Uploading Document"

      // close the existing fileNotify notifiction
      closeNotification.close()

      // Enabling the loading screen to indicate that api call is to be loading.
      showLoading = true

      let reqBody = {
        documentID: $BadgePublish.documentId,
        file: fileToBeUploaded,
      }

      let apiData = await filehashGeneration($BadgePublish.documentId, reqBody)

      // update the Publish Badge store values from data got from the api call
      $BadgePublish.uri = `/ipfs/${apiData.filename}`
      $BadgePublish.fileHash = apiData.fileHash

      updateBadgePublish($BadgePublish)

      push(`/publish/badge/preview?documentId=${query.documentId}&badgeId=${query.badgeId}`)
    } catch (error) {
      if (error == "P2BCODE::DOCUMENT_DOES_NOT_EXIST") {
        localStorage.removeItem("P2BBadgePublish")
        $BadgePublish = {}
        push("/publish/badge")
      }
      const info = "PAGE: Badge Publish (Upload Document)\nEVENT: During processing of uploaded document"
      closeNotification = notify.danger(error, info)
      $BadgePublish.uri = ""
    } finally {
      showLoading = false
    }
  }
</script>

<svelte:window
  on:load={() => {
    push(`/publish/badge?documentId=${query.documentId}&badgeId=${query.badgeId}`)
  }}
/>
<svelte:head>
  <title>Publish Badge</title>
</svelte:head>

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  <div class="mx-auto h-auto w-full max-w-[920px] px-6 pb-40 pt-6 lg:px-0">
    <Header title="Upload Document" bind:showLoading bind:msg redirectUrl="/publish/badge/doctemplate?documentId={query.documentId}&badgeId={query.badgeId}" />

    <div class="relative flex min-h-[470px] flex-col justify-between gap-6 rounded-md bg-white p-6 dark:bg-mdGray mobile:p-12">
      <div class="flex flex-col justify-start gap-3">
        <div class="mx-auto flex w-full flex-col items-center justify-center gap-3 overflow-hidden rounded-md">
          {#if !Object.keys(dynamicImages).length}
            <div class="w-2/3">
              <div class="relative flex w-full items-center justify-center">
                <img src={$BadgePublish.uri} alt="badge-cert" class="aspect-auto w-full rounded-md" />
              </div>
            </div>
          {:else}
            <div class=" w-full text-base text-gray-400">You have dynamic images for this File Template. Please upload the appropriate images for the process.</div>
            <div class="flex w-full flex-wrap">
              {#each Object.entries(dynamicImages) as [key, value]}
                <div class="w-full space-y-1 p-2 md:w-1/2">
                  <label for={key} class="text-gray-500">{key}</label>
                  <div class="relative flex h-40 w-full justify-center rounded-md bg-white dark:bg-bodyblack">
                    {#if !value}
                      <div class="relative flex h-full w-full flex-col items-center justify-center gap-3 rounded-md border border-dashed border-gray-200 p-3 hover:border-gray-200/50 hover:bg-[#f7f7f7] hover:dark:bg-bodyblack">
                        <input
                          on:change={async (e) => {
                            try {
                              let files = e.target.files[0]
                              await validateFile(files)
                              dynamicImages[key] = URL.createObjectURL(files)
                            } catch (error) {
                              console.error(error)
                              e.target.value = ""
                              closeNotification.close()
                              const info = "PAGE: Badge Publish (Upload Document)\nEVENT: During validation of uploaded document"
                              closeNotification = notify.danger(error, info)
                            }
                          }}
                          name="signature"
                          id="signature"
                          type="file"
                          accept=".png, .jpeg, .jpg"
                          class="absolute inset-0 cursor-pointer opacity-0"
                        />
                        <div class="text-xl text-blue-500 lg:text-3xl">
                          <i class="fa-solid fa-cloud-arrow-up" />
                        </div>
                        <p class="md:txet-base select-none text-center text-xs font-medium text-gray-200 md:text-sm">Select a file by dragging and dropping it, or Click here to upload</p>
                        <p class="select-none text-center text-xs font-normal text-blue-500 md:text-sm">Supported formats: .png, .jpg, .jpeg only.</p>
                      </div>
                    {:else}
                      <div class="flex h-full w-fit items-center">
                        <div class=" h-auto overflow-hidden rounded-md">
                          <button
                            on:click={() => {
                              dynamicImages[key] = ""
                            }}
                            type="button"
                            class="absolute right-3 top-2 text-xl text-red-500 hover:text-red-600 disabled:cursor-not-allowed"
                          >
                            <i class="fa-solid fa-circle-xmark" />
                          </button>
                          <!-- svelte-ignore a11y-img-redundant-alt -->
                          <img src={value} class="aspect-auto h-auto max-h-40" alt="signatory image" />
                        </div>
                      </div>
                    {/if}
                  </div>
                  <!-- {#if !value}
                    <div class="relative flex w-full flex-col items-center justify-center gap-3 rounded-md border border-dashed border-gray-200 px-12 py-12 hover:border-gray-200/50 hover:bg-[#f7f7f7] hover:dark:bg-bodyblack">
                      <input
                        id={key}
                        on:change={(e) => {
                          dynamicImages[key] = URL.createObjectURL(e.target.files[0])
                        }}
                        type="file"
                        accept=".pdf,.png,.jpeg,.jpg"
                        class="absolute inset-0 cursor-pointer opacity-0"
                      />
                      <div class="text-xl text-blue-500 lg:text-3xl">
                        <i class="fa-solid fa-cloud-arrow-up" />
                      </div>
                      <span class="md:txet-base select-none text-center text-sm font-medium text-gray-200">Select a file by dragging and dropping it, or Click here to upload</span>
                      <span class="select-none text-center text-xs font-normal text-gray-100 md:text-sm">Maximum Size 2MB</span>
                      <span class="select-none text-center text-xs font-normal text-blue-500 md:text-sm">Supported formats: IMAGE only.</span>
                    </div>
                  {:else}
                    <img src={value} alt="" />
                  {/if} -->
                </div>
              {/each}
            </div>
          {/if}
        </div>
      </div>

      <div class="flex w-full flex-col justify-between gap-3 mobile:flex-row sm:justify-end">
        {#if !Object.keys(dynamicImages).length}
          {#if haveDynamicFiles}
            <button on:click={() => checkDynamicImage(fileData)} type="button" class="flex h-9 w-auto min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-yellow-500 px-2 text-sm font-medium text-white hover:bg-yellow-600 hover:text-white focus:outline-none active:bg-yellow-500 disabled:cursor-not-allowed lg:px-4">
              <i class="fa-solid fa-rotate-left" />
              <span class="select-none md:block">&nbsp;&nbsp;Undo</span>
            </button>
          {/if}
          <button bind:this={publishBtn} on:click={handleUpload} type="button" class="{$BadgePublish.uri ? 'bg-blue-500 hover:bg-blue-600 active:bg-blue-500' : 'cursor-not-allowed bg-blue-300 hover:bg-blue-400 active:bg-blue-200'} flex h-9 w-auto min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] px-2 text-sm font-medium text-white hover:text-white focus:outline-none disabled:cursor-not-allowed lg:px-4">
            <i class="fa-solid fa-check" />
            <span class="select-none md:block">&nbsp;&nbsp;Confirm and Upload</span>
          </button>
        {:else}
          <button on:click={generateDynamicImage} type="button" class="flex h-9 w-auto min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none active:bg-green-500 lg:px-4">
            <i class="fa-solid fa-check" />
            <span class="select-none md:block">&nbsp;&nbsp;Generate File</span>
          </button>
        {/if}
      </div>
      {#if showLoading}
        <LoadingScreen {msg} />
      {/if}
    </div>
  </div>
  <Footer />
</div>
